"use client";
import { getClientCookie } from "@lib/cookies.client";

const IOS_APP_PLATFORMS = new Set([
  "ios_app",
  "ackodrive_ios_app",
]);

const ANDROID_APP_PLATFORMS = new Set([
  "android_app",
  "ackodrive_android_app",
]);

export const getAppOsFromPlatformValue = (
  platform: string | null | undefined
): "iOS" | "Android" | "" => {
  if (!platform || typeof platform !== "string") {
    return "";
  }
  if (IOS_APP_PLATFORMS.has(platform)) {
    return "iOS";
  }
  if (ANDROID_APP_PLATFORMS.has(platform)) {
    return "Android";
  }
  return "";
};

export const getPlatform = (): string | undefined => {
    return getClientCookie("webview") ? getClientCookie("webview") : getClientCookie("source");
};

export const inApp = (): boolean => {
  const platform = getPlatform();
  if (!platform || typeof platform !== "string") {
    return false;
  }
  return IOS_APP_PLATFORMS.has(platform) || ANDROID_APP_PLATFORMS.has(platform);
};